import { useState, MouseEvent } from 'react';
import { useHistory } from 'react-router-dom';

import firebase from 'firebase';
import { database } from '../services/firebase';
import { useAuth } from '../hooks/useAuth';
import { toast } from 'react-toastify';
import { ButtonSignOut } from '../components/ButtonSignOut';
import { Button } from '../components/Button';
import { BackgroundSVG } from '../components/BackgroundSVG';

import logoCarrano from '../assets/logo.svg';
import '../styles/main.scss'

export function Home() {
    const [cnpj, setCnpj] = useState('');
    const history = useHistory();
    const { user } = useAuth();

    async function signOut(event: MouseEvent) {
        event.preventDefault();

        firebase.auth().signOut().then(() => {
            history.push('/')
        }).catch((error) => {
            alert('Você não esta logado!')
        });
    }

    async function handleJoinStore() {

        if (!user) {
            history.push('/');

        } else {

            try {
                const storeRef = await database.ref(`stores/${cnpj}`).get();
                if (!storeRef.exists()) {
                    toast.error('CNPJ não existe, favor digitar um válido ou entre em contato com a Carrano!');
                } else {
                    history.push(`/dealer/${cnpj}`)
                }
            } catch (err) {
                toast.error('Não foi possível autenticar, tente novamente em instantes!');
            }
        }
    }

    return (
        <>
            <BackgroundSVG />

            <div className="container">
                <div className="logo-container">
                    <img src={logoCarrano} alt="CARRANO Logo" />
                </div>
                <h2 className="text-secondary text-regular text-center">SALES</h2>
                <div className="login-container">
                    <div className="wrapper-userdata">
                        <div className="wrapper-userdata-childs">
                            <img src={user?.avatar} alt="user-img" className="user-avatar" />
                            <ButtonSignOut onClick={signOut} />
                        </div>
                        <span className="text-username">{user?.name}</span>
                    </div>
                    <h3 className="text-center text-secondary text-light color-base-red">Digite o CNPJ<span className="text-secondary color-base-red">de sua loja!</span></h3>
                    <div className="input-box">
                        <input
                            className="user-input"
                            type="text"
                            name="text"
                            id="text"
                            placeholder="Digite aqui (somente números)"
                            onChange={event => {
                                event.preventDefault();
                                setCnpj(event.target.value);
                            }}
                        />
                        <Button title="ENTRAR" onClick={handleJoinStore} disabled={!cnpj} />
                    </div>
                </div>
            </div>
        </>
    )
}

